import { List } from 'immutable';
import { getMostSpecificPathFromKeys, getActionTypeKey, getEnrollTypeKey } from 'automation-ui-log-events/utils/messagePathUtils';
import { getState, getType, getUnenrollType, getErrorType, getErrorSubType, getFailType, getFailSubType } from 'automation-ui-log-events/records/LogEvent/utils';
import { getClassicLogEvent } from 'automation-ui-log-events/records/LogEvent/contextMapUtils';
export const getLogEventMessageKeys = (logEvent, objectTypeId) => {
  const logEventType = getType(logEvent);
  const state = getState(logEvent);
  const actionType = getActionTypeKey(logEvent);
  const enrollType = getEnrollTypeKey(logEvent);
  const unenrollType = getUnenrollType(logEvent);
  const classicLogEvent = getClassicLogEvent(logEvent);
  const failType = getFailType(logEvent);
  const failSubType = getFailSubType(logEvent);
  const errorType = getErrorType(logEvent);
  const errorSubType = getErrorSubType(logEvent);
  return List([logEventType, state, actionType || enrollType || unenrollType || classicLogEvent, errorType || failType, errorSubType || failSubType, objectTypeId]);
};
export const getSupplementalLogEventMessageKeys = (logEvent, supplementalKey, objectTypeId) => {
  const logEventType = getType(logEvent);
  const state = getState(logEvent);
  const actionType = getActionTypeKey(logEvent);
  const enrollType = getEnrollTypeKey(logEvent);
  const unenrollType = getUnenrollType(logEvent);
  const classicLogEvent = getClassicLogEvent(logEvent);
  const failType = getFailType(logEvent);
  const failSubType = getFailSubType(logEvent);
  const errorType = getErrorType(logEvent);
  const errorSubType = getErrorSubType(logEvent);
  return List([logEventType, state, actionType || enrollType || unenrollType || classicLogEvent, errorType || failType, supplementalKey, errorSubType || failSubType, objectTypeId]);
};
export const getSupplementalLogEventMessage = supplementalKey => (logEvent, objectTypeId) => {
  const supplementalMessage = getMostSpecificPathFromKeys(getSupplementalLogEventMessageKeys(logEvent, supplementalKey, objectTypeId));

  // Only take supplemental message if key was a hit (i.e. if the
  // supplemental key was in the path) and discard the message if
  // if is a fallback
  if (!supplementalMessage || supplementalMessage.path.search(new RegExp(`.${supplementalKey}([._].+)?$`)) === -1) {
    return undefined;
  }
  return supplementalMessage;
};
export const getLogEventMessage = (logEvent, objectTypeId, prevPathInConfig) => {
  const subtypedMessage = getMostSpecificPathFromKeys(getLogEventMessageKeys(logEvent, objectTypeId));
  if (!subtypedMessage || subtypedMessage.path === prevPathInConfig) {
    return undefined;
  }
  return subtypedMessage;
};